export enum LorenzFormLayoutEnum {
	DEFAULT = 'layout-default',
	FLOATING_LABELS = 'layout-floating-labels'
}

export function getLorenzFormLayoutEnumString(value?: LorenzFormLayoutEnum | null): string {
	return value ?? LorenzFormLayoutEnum.DEFAULT;
}
